module.exports = __webpack_public_path__ + "static/banner-image-5d8ee626a944b8ee0058d5a48104d25d.png";